import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c1fa552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container card p-4" }
const _hoisted_2 = {
  class: "card p-4 d-flex justify-content-center",
  style: {"max-width":"70%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Defina o som de aviso", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _ctx.sound,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sound) = $event)),
        placeholder: "Defina o som de aviso"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arraySounds, (sound) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: sound,
              value: sound,
              key: sound
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
        default: _withCtx(() => [
          _createTextVNode("Salvar")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}